import React from 'react'
import { connect } from 'react-redux'
import bowser from 'bowser'
import PropTypes from 'prop-types'
import { Component } from 'macguffin'

/**
 * A simple toggle DOM element, used for creating
 * a setting toggle.
 */
@connect(state => ({ session: state.session }))
export default class Toggle extends Component {
  static propTypes = {
    name: PropTypes.string,
    setting: PropTypes.func,
    toggled: PropTypes.bool,
    toggleFunction: PropTypes.func
  }

  /**
   * Run when a toggle is clicked.
   * Will call the "setting" callback to toggle the setting state.
   * Has an option to call another function "toggleFunction" with the new
   * toggle state.
   */
  toggle = () => {
    if (this.props.toggleFunction)
      this.props.toggleFunction(!this.props.toggled)
    if (this.props.setting)
      this.props.setting()
  }

  /**
   * Renders a toggle button DOM element.
   */
  render() {
    const { props } = this
    const { name, toggled, disabled } = props
    const turnOnOrOffText = ['sound', 'sfx', 'music'].includes(name)
      ? `${this.t(toggled ? 'settings.toggle.description.turnOff' : 'settings.toggle.description.turnOn')} `
      : ''

    return (
      <React.Fragment>
        <div className={`toggle ${disabled ? 'disabled' : ''}`}>
          <div className="toggle-text">
            <div className="toggle-title">{this.t(`settings.toggle.${name}`).toUpperCase()}</div>
            <div className="toggle-desc">{`${turnOnOrOffText}${this.t(`settings.toggle.description.${name}`)}`}</div>
          </div>
          <div className="toggle-bg-wrapper">
            <div className={`toggle-bg ${toggled ? 'on' : 'off'} type-${name} ${bowser.mobile || bowser.tablet ? 'no-hover' : ''}`} onClick={this.toggle}>
              <div className={`toggle-thumb ${toggled ? 'on' : ''}`} />
              <div className={`toggle-thumb inner ${toggled ? 'on' : ''}`} />
            </div>
          </div>
        </div>
        <div className="divider" />
      </React.Fragment>
    )
  }
}
